import {EventEmitter, Injectable} from '@angular/core';
import {ApiService} from "../api/api.service";
import {finalize, map, pluck} from "rxjs/operators";
import {HttpUrlEncodingCodecCorrected} from "../api/http-url-encoding-codec";
import {saveAs} from 'file-saver';
import {HttpClient} from "@angular/common/http";
import {InterfaceProviderService} from "../basic-entity-back/services/interface-provider.service";
import {Resource} from "../api/resource";
import {SessionService} from "../session/session.service";
import {ErrorDisplayService} from "../basic-entity-front/services/error-display.service";
import {nombrePdf} from "./nombre-pdf";

/**
 * Este servicio coordina la búsqueda entre el header y el table component
 * que se esté mostrando.
 */
@Injectable({
    providedIn: 'root'
})
export class FacturasService {

    _finalizadoEmitter = new EventEmitter<boolean>();
    /** Se calcula en cada petición: la sesión puede renovarse (caducar y volver a entrar) sin recargar la pestaña. */
    private get _authorization(): string {
        return 'Bearer ' + this.sessionService.token.token;
    }

    constructor(private apiService: ApiService, private _http: HttpClient, private interfaceProvider: InterfaceProviderService, private sessionService: SessionService,
                private _errorDisplay: ErrorDisplayService) {
    }

    imprimir(entity: Resource) {
        const titulo = this.interfaceProvider.interfaceForModel(entity.modelType).name;
        this.apiService.patch(`${entity.iri}/descargar`, {})
            .pipe(
                ApiService.sTakeBody(),
                pluck('downloadToken'),
                map((token: string) =>
                    ApiService.sCompleteUrl(`${entity.iri}/pdf?token=${new HttpUrlEncodingCodecCorrected().encodeValue(token)}`))
            )
            .subscribe(
                (url: any) => {
                    this._http.get(url, {responseType: "arraybuffer", headers: {Authorization: this._authorization}})
                        .subscribe((datos: any) => {
                            const filename = nombrePdf(titulo, entity['numeroFactura'], entity['cliente']);
                            const blob = new Blob([datos], {type: 'application/pdf'});
                            saveAs(blob, filename);
                            this._finalizadoEmitter.next(true);
                        }, error => this._falloDescarga(error));

                }, error => this._finalizadoEmitter.next(true));
    }

    /**
     * El fichero no ha llegado: se avisa al usuario (antes terminaba callado) y se quita la barra de carga.
     * Solo para el GET: los fallos del PATCH ya los enseña ApiService, y se verían dos veces.
     */
    private _falloDescarga(error: any) {
        this._errorDisplay.displayErrorAlDescargar(error);
        this._finalizadoEmitter.next(true);
    }

    get finalizadoEmitter() {
        return this._finalizadoEmitter;
    }
}
